@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.linkshare

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.linkshare.OpenShareResponseDto

object OpenLinkShareEndpoint : EndPoint<OpenLinkShareEndpoint.Request, OpenLinkShareEndpoint.Response>() {
    class Request(
        val shareToken: String,
        val os: String?,
        val osVersion: String?,
        val webVersion: String?,
        val deviceUuid: String?,
        val userAgent: String?,
        val referrer: String?,
    )

    class Response(
        val open: OpenShareResponseDto,
    )
}
